import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { resetPass } from "../../apis/resetPass";

export default function ConfirmPassButton({
  isPasswordValid,
  newPassValue,
  confirmPassValue,
  token,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  async function handleClick(e) {
    if (isPasswordValid === false) {
      console.log("Password invalid");
      console.log(isPasswordValid);
    } else {
      //API call
      console.log(newPassValue, confirmPassValue, token);
      const result = await resetPass(newPassValue, confirmPassValue, token);
      console.log(result);
      navigate("/login");
    }
  }
  return <PrimaryButton text={t("enter_confirm_password")} onClick={handleClick} />;
}
